module.exports = __webpack_public_path__ + "static/media/galerija_2019 (5).8cf73c67.jpg";